module.exports = __webpack_public_path__ + "static/media/yt.85556bea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/yt.svg
// module id = 292
// module chunks = 0